import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  TableHead,
  Table,
  Button,
  TextField,
  IconButton,
  Select,
  MenuItem,
  Modal,
  Skeleton,
  InputAdornment,
  Tooltip,
  FormControl,
  InputLabel,
} from "@mui/material";
import { headingStyle, tableRowLab } from "../../style/LapPageStyle";
import CloseIcon from "@mui/icons-material/Close";
import { primaryBtn } from "../../style/AppointmentStyle";
import { primaryBtnTeal } from "../../style/PatientDetailsStyle";
import { showToast } from "../../utils/toastUtil";
import { useNavigate } from "react-router-dom";
import { autoFocusOffWithOutBorder } from "../../style/PatinetFormStyle";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import json_icon from "../../assets/json_icon.svg";
import csv_icon from "../../assets/csv_icon.svg";
import CustomModal from "../CustomModal/CustomModal";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import supplier from "../../assets/supplier.svg";
import SupplierDetails from "./SupplierDetails";
import NewSupplier from "./NewSupplier";
import EditSupplier from "./EditSupplier";
import UseFetchSupplierList from "../../helper/UseFetchSupplierList";
import { deleteSupplier } from "../../connections/deleteApi";
import {
  generateCSV,
  handleShowJson,
  formattedDate,
  formattedDateWithoutBg,
  handleDownloadCsvSupplier,
} from "../../utils/constantFunctions";
import SearchIcon from "@mui/icons-material/Search";
import useDebounce from "../../hooks/UseDebounce";
import LedgerEntries from "./LedgerEntries";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import AddlegderEntries from "./AddlegderEntries";
import AddCardOutlinedIcon from "@mui/icons-material/AddCardOutlined";

const Supplier = ({ onClose }) => {
  // console.log(medicines); setEditSupplierOrderModal
  const [filterModal, setFilterModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [detailsModal, setDetailsModal] = useState(false);
  const [editSupplierOrderModal, setEditSupplierOrderModal] = useState(false);
  const [newPurchaseOrderModal, setNewPurchaseOrderModal] = useState(false);
  const [page, setPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(10);
  const [id, setId] = useState(null);
  const [supplierInput, setSupplierInput] = useState(null);
  const [goToPage, setGoToPage] = useState("");
  const [openLedger, setOpenLedger] = useState(false);
  const [supplierPaymentModal, setSupplierPaymentModal] = useState(false);

  const handleSupplierChange = (e) => {
    // console.log('working', e);
    e.preventDefault();
    setSupplierInput(e?.target?.value);
  };

  const debouncedInputSupplier = useDebounce(supplierInput, 800);

  const {
    data: supplierList,
    refetch,
    isLoading,
  } = UseFetchSupplierList(page, itemPerPage, debouncedInputSupplier);

  const totalRecords = supplierList?.meta?.total_count || 0;
  const totalPage = Math.ceil(totalRecords / itemPerPage);

  const handlePrevious = () => {
    if (page > 1) setPage((prev) => prev - 1);
  };

  const handleNext = () => {
    if (page < totalPage) setPage((prev) => prev + 1);
  };

  useEffect(() => {
    refetch(page, itemPerPage);
  }, [page, itemPerPage]);

  const navigate = useNavigate();

  const handleDelete = async (id) => {
    setDeleteModal(false);
    const res = await deleteSupplier(id);
    console.log(res);

    showToast(res?.status?.message || res?.status?.status, res?.status?.status);
    if (res?.status?.status) {
      refetch(page, itemPerPage);
    }
  };

  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          height: "90vh",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        {/* //modals for delete and filter */}

        <Modal
          open={deleteModal}
          onClose={() => setDeleteModal(false)}
          sx={{
            position: "absolute",
            top: "25%",
            // left:'50%',
            width: "450px",
            // height:"400px",
            margin: "auto",
            //  display: "flex",
            //  alignItems: "flex-start",
            //  justifyContent: "center",
            //  overflow: "auto",
            borderRadius: "20px",
          }}
        >
          <Box
            sx={{
              mt: 2,
              bgcolor: "background.paper",
              borderRadius: 3.6,
              boxShadow: 24,
              p: 4.5,
              "&:focus": {
                outline: "none",
              },
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography textAlign={"center"}>Are you sure?</Typography>
              <Typography textAlign={"center"}>
                You want to delete these selected purchase orders?
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "flex",
                gap: "25px",
                width: "max-content",
                margin: "auto",
                marginTop: "40px",
              }}
            >
              <Button
                sx={{
                  backgroundColor: "#FF392B",
                  color: "white",
                  border: "",
                  width: "150px",
                  borderRadius: "5px",
                  fontSize: "12px",
                  textTransform: "capitalize",
                  "&:hover": {
                    backgroundColor: "red",
                  },
                }}
                onClick={() => {
                  handleDelete(id);
                }}
              >
                Delete
              </Button>
              <Button
                onClick={() => setDeleteModal(false)}
                sx={{
                  backgroundColor: "white",
                  color: "black",
                  border: "2px solid #FF392B",
                  width: "150px",
                  borderRadius: "5px",
                  fontSize: "12px",
                  textTransform: "capitalize",
                }}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Modal>

        <Modal
          open={filterModal}
          onClose={() => setFilterModal(false)}
          sx={{
            position: "absolute",
            top: "14%",
            // left:'50%',
            width: "340px",
            // height:"400px",
            margin: "auto",
            //  display: "flex",
            //  alignItems: "flex-start",
            //  justifyContent: "center",
            //  overflow: "auto",
            borderRadius: "20px",
          }}
        >
          <Box
            sx={{
              mt: 2,
              bgcolor: "background.paper",
              borderRadius: "20px",
              boxShadow: 24,
              p: 1,
              "&:focus": {
                outline: "none",
              },
            }}
          >
            <Grid container spacing={2} sx={{ padding: "9px" }}>
              <Grid item xs={12}>
                <Typography
                  variant="subTitle116px"
                  fontWeight={"600"}
                  textAlign={"center"}
                  margin={"auto"}
                >
                  Filters
                </Typography>
              </Grid>

              {/* <Grid item xs={12}>
        <Typography  variant="subTitle116px" >Suppliers</Typography>
      </Grid> */}

              {/* Filter Selection */}
              <Grid item xs={12}>
                <Select
                  fullWidth
                  defaultValue=""
                  placeholder="Select Filter"
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove border
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove border on hover
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Ensure border remains none on focus
                    },
                    "& .MuiSelect-select": {
                      padding: "9px",
                      borderRadius: "15px",
                      backgroundColor: "neutral.blueShadeBg",
                    },
                    "&:hover": {
                      boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                    },
                  }}
                  renderValue={(selected) => {
                    if (!selected) {
                      return (
                        <span style={{ color: "text.default_grey" }}>
                          Select filter
                        </span>
                      );
                    }
                    return selected === "filter1"
                      ? "filter2"
                      : selected === "filter3"
                        ? "filter3"
                        : "select filter";
                  }}
                >
                  <MenuItem value="filter1">Filter 1</MenuItem>
                  <MenuItem value="filter2">Filter 2</MenuItem>
                  <MenuItem value="filter3">Filter 3</MenuItem>
                </Select>
              </Grid>

              {/* Purchase Date */}
              <Grid item xs={12}>
                <Typography variant="subTitle116px">Purchase Date</Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  sx={autoFocusOffWithOutBorder}
                  label="From"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  sx={autoFocusOffWithOutBorder}
                  label="To"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              {/* Department Selection */}
              <Grid item xs={12}>
                <Typography variant="subTitle116px">Department</Typography>
                <Select
                  fullWidth
                  defaultValue=""
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove border
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove border on hover
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Ensure border remains none on focus
                    },
                    "& .MuiSelect-select": {
                      padding: "9px",
                      borderRadius: "15px",
                      backgroundColor: "neutral.blueShadeBg",
                    },
                    "&:hover": {
                      boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                    },
                  }}
                >
                  <MenuItem value="dept1">Department 1</MenuItem>
                  <MenuItem value="dept2">Department 2</MenuItem>
                  <MenuItem value="dept3">Department 3</MenuItem>
                </Select>
              </Grid>

              {/* Created At */}
              <Grid item xs={12}>
                <Typography variant="subTitle116px">Created At</Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  sx={autoFocusOffWithOutBorder}
                  label="From"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  sx={autoFocusOffWithOutBorder}
                  label="To"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              {/* Buttons */}
              <Grid item xs={6}>
                <Button
                  fullWidth
                  variant="subTitle116px16px"
                  sx={{ ...primaryBtnTeal, color: "white" }}
                >
                  Apply
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  onClick={() => setFilterModal(false)}
                  fullWidth
                  variant="subTitle116px16px"
                  sx={{ ...primaryBtn, color: "white", border: "none" }}
                >
                  Clear Filters
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Box
          sx={{
            overflowY: "auto",
            maxHeight: "80vh",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            "-ms-overflow-style": "none",
            "scrollbar-width": "none",
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            position="sticky"
          >
            <Box></Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "9px",
              }}
            >
              <img
                src={supplier}
                alt=""
                sx={{
                  color: "neutral.navyBlue",
                  marginBottom: "4px",
                  marginRight: "8px",
                }}
              />
              <Typography
                variant="heading_Large"
                fontWeight={700}
                gutterBottom
                sx={headingStyle}
              >
                Suppliers
              </Typography>
            </Box>
            <IconButton sx={{ marginBottom: "0rem" }} onClick={onClose}>
              <CloseIcon size="small" sx={{ color: "red" }} />
            </IconButton>
          </Box>

          <Box
            mt={1}
            mb={-1}
            marginLeft={-1}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            position="sticky"
            paddingX="25px"
            gap="50px"
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              position="sticky"
              paddingX="0px"
              gap="50px"
            >
              <Box>
                {" "}
                <AddRoundedIcon
                  onClick={() => setNewPurchaseOrderModal(true)}
                  sx={{
                    backgroundColor: "#FFE7DC",
                    p: "4px",
                    width: "20px",
                    color: "#FF8D1E",
                    borderRadius: "8px",
                    cursor: "pointer",
                  }}
                />
              </Box>
              {/* <Box > <AddRoundedIcon onClick={()=>setNewPurchaseOrderModal(true)} sx={{backgroundColor:"#FFE7DC" ,p:'4px',  width:"20px", color:"#FF8D1E" , borderRadius:"8px" ,cursor:"pointer"}}   /></Box> */}
              {/* 
            <Box
              onClick={() => setFilterModal(true)}
              sx={{
                display: "flex",
                alignItems: "center",
                marginRight: "20px",
              }}
            >
             
            </Box> */}

              <Box>
                <TextField
                  sx={{
                    ...autoFocusOffWithOutBorder,
                    minWidth: "250px",
                    maxWidth: "350px",
                  }}
                  type="text"
                  className="form-control"
                  placeholder="Search Supplier"
                  value={supplierInput}
                  onChange={handleSupplierChange}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
            </Box>

            {/* <IconButton  >
          <TuneRoundedIcon size="small"  sx={{color:"#0067FF"}}/>  
        </IconButton>
        <Typography>
         Filters
        </Typography>  */}
            {/* <Box>
              <Button
                onClick={() => setSupplierPaymentModal(true)}
                sx={{ ...primaryBtnTeal, minWidth: 190 }}
              >
                Add Supplier Payment
              </Button>
            </Box> */}
          </Box>

          <Grid item xs={12}>
            <TableContainer sx={{ mt: 2, width: "100%" }}>
              <Table sx={{ width: "100%" }}>
                <TableHead stickyHeader>
                  <TableRow sx={{ textAlign: "center" }}>
                    {/* <TableCell
                variant="body1_text_bold" 
                  sx={{
                    borderTopLeftRadius:"20px",
                    
                  color: 'neutral.black',
                    p: "8px", 
                    textAlign: "center",
                  }}
                > 
                  <Checkbox/>
                </TableCell> */}

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      ID
                    </TableCell>
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        //  paddingX:"4px",
                        textAlign: "center",
                        width: "200px",
                      }}
                    >
                      Name
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        width: "130px",
                        paddingRight: "30px",
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Mobile
                    </TableCell>
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Email
                    </TableCell>
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      GST
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Address
                    </TableCell>
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Created at
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Updated at
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>

                {isLoading ? (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={10} sx={{ p: 0 }}>
                        <Box
                          sx={{
                            rowGap: 1.2,
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <Skeleton
                            variant="rectangular"
                            sx={{
                              width: "100%",
                              height: "50px", // Adjust to match your table row height
                              backgroundColor: "#f0f0f0", // Light grey color
                            }}
                          />

                          <Skeleton
                            variant="rectangular"
                            sx={{
                              width: "100%",
                              height: "50px", // Adjust to match your table row height
                              backgroundColor: "#f0f0f0", // Light grey color
                            }}
                          />

                          <Skeleton
                            variant="rectangular"
                            sx={{
                              width: "100%",
                              height: "50px", // Adjust to match your table row height
                              backgroundColor: "#f0f0f0", // Light grey color
                            }}
                          />

                          <Skeleton
                            variant="rectangular"
                            sx={{
                              width: "100%",
                              height: "50px", // Adjust to match your table row height
                              backgroundColor: "#f0f0f0", // Light grey color
                            }}
                          />

                          <Skeleton
                            variant="rectangular"
                            sx={{
                              width: "100%",
                              height: "50px", // Adjust to match your table row height
                              backgroundColor: "#f0f0f0", // Light grey color
                            }}
                          />
                        </Box>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : supplierList?.payload?.suppliers?.length > 0 ? (
                  <TableBody>
                    {supplierList?.payload?.suppliers?.map((item, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          ...tableRowLab,
                          textAlign: "center",
                          backgroundColor: "neutral.blueShadeBg",
                          borderBottom: "8px solid white",
                          borderTop: "4px solid white",
                        }}
                      >
                        {/* <TableCell
                variant="subTitle116px" 
                  sx={{
                    borderTopLeftRadius:"20px",
                    borderBottomLeftRadius:"20px",
                    color: 'neutral.black',
                    p: "8px", 
                    textAlign: "center",
                  }}
                > 
                  <Checkbox/>
                </TableCell> */}

                        <TableCell
                          sx={{
                            color: "neutral.black",
                            p: "8px",
                            textAlign: "center",
                            borderTopLeftRadius: "20px",
                            borderBottomLeftRadius: "20px",
                          }}
                        >
                          <Typography
                            variant="subTitle116px"
                            sx={{ color: "#3A3A3A" }}
                          >
                            {item?.id}
                          </Typography>
                        </TableCell>

                        <TableCell
                          variant="body1_text_bold"
                          sx={{
                            color: "neutral.black",
                            p: "8px",
                            //  paddingX:"4px",
                            textAlign: "center",
                            width: "200px",
                          }}
                        >
                          {/* <Typography variant="subTitle116px"
                            sx={{
                              color: "#3A3A3A",
                            }}
                          >
                            {item?.name}
                          </Typography> */}
                          <Tooltip
                            title={item?.name}
                            arrow
                            onClick={() => {
                              setDetailsModal(true);
                              setId(item?.id);
                            }}
                          >
                            <Typography
                              variant="subTitle116px"
                              sx={{
                                color: "#0067FF",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxWidth: 180, // set max width as needed
                                cursor: "pointer",
                                display: "inline-block",
                              }}
                            >
                              {item?.name}
                            </Typography>
                          </Tooltip>
                        </TableCell>

                        <TableCell
                          variant="body1_text_bold"
                          sx={{
                            color: "neutral.black",
                            p: "8px",
                            textAlign: "center",
                          }}
                        >
                          <Typography
                            variant="subTitle116px"
                            sx={{
                              color: "#3A3A3A",
                            }}
                          >
                            {" "}
                            {item?.phone?.split(" ")[0]}{" "}
                          </Typography>
                        </TableCell>

                        <TableCell
                          variant="body1_text_bold"
                          sx={{
                            color: "neutral.black",
                            p: "8px",
                            textAlign: "center",
                          }}
                        >
                          <Typography
                            variant="subTitle116px"
                            sx={{
                              color: "#3A3A3A",
                            }}
                          >
                            {" "}
                            {item?.email}{" "}
                          </Typography>
                        </TableCell>
                        <TableCell
                          variant="body1_text_bold"
                          sx={{
                            color: "neutral.black",
                            p: "8px",
                            textAlign: "center",
                          }}
                        >
                          <Typography
                            variant="subTitle116px"
                            sx={{
                              color: "#3A3A3A",
                            }}
                          >
                            {" "}
                            {item?.gst_no}
                          </Typography>
                        </TableCell>

                        <TableCell
                          variant="body1_text_bold"
                          sx={{
                            color: "neutral.black",
                            p: "8px",
                            textAlign: "center",
                          }}
                        >
                          <Tooltip title={item?.address} arrow>
                            <Typography
                              variant="subTitle116px"
                              sx={{
                                color: "#3A3A3A",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxWidth: 150, // set max width as needed
                                cursor: "pointer",
                                display: "inline-block",
                              }}
                            >
                              {item?.address}
                            </Typography>
                          </Tooltip>
                        </TableCell>

                        <TableCell
                          variant="body1_text_bold"
                          sx={{
                            color: "neutral.black",
                            p: "8px",
                            textAlign: "center",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <Tooltip
                              title={`Create time - ${item.created_at.split(" ")[1]}`}
                              arrow
                            >
                              <Typography
                                variant="subTitle116px"
                                fontSize="14px"
                                sx={{
                                  color: "#3A3A3A",
                                  cursor: "pointer", // optional, to indicate hover
                                }}
                              >
                                <Typography
                                  variant="subTitle116px"
                                  fontSize={"14px"}
                                  fontWeight={"400"}
                                  sx={{ color: "#3A3A3A" }}
                                >
                                  {" "}
                                  {formattedDateWithoutBg(
                                    item?.created_at?.split(" ")[0],
                                  )}{" "}
                                </Typography>
                              </Typography>
                            </Tooltip>
                          </Box>
                        </TableCell>

                        <TableCell
                          variant="body1_text_bold"
                          sx={{
                            color: "neutral.black",
                            p: "8px",
                            textAlign: "center",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <Tooltip
                              title={`Create time - ${item?.updated_at?.split(" ")[1]}`}
                              arrow
                            >
                              <Typography
                                variant="subTitle116px"
                                fontSize="14px"
                                sx={{
                                  color: "#3A3A3A",
                                  cursor: "pointer", // optional, to indicate hover
                                }}
                              >
                                <Typography
                                  variant="subTitle116px"
                                  fontSize={"14px"}
                                >
                                  {" "}
                                  {formattedDateWithoutBg(
                                    item?.updated_at?.split(" ")[0],
                                  )}{" "}
                                </Typography>
                              </Typography>
                            </Tooltip>
                          </Box>
                        </TableCell>

                        <TableCell
                          alignItems={"center"}
                          sx={{
                            borderTopRightRadius: "20px",
                            borderBottomRightRadius: "20px",
                            alignItems: "center",
                            marginLeft: "50px",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              gap: "8px",
                              justifyContent: "center",
                              marginRight: "-8px",
                            }}
                          >
                            <AddCardOutlinedIcon
                              onClick={() => {
                                setSupplierPaymentModal(true);
                                setId(item?.id);
                              }}
                              sx={{
                                backgroundColor: "#0c73a3",
                                p: "4px",
                                width: "18px",
                                color: "white",
                                borderRadius: "5px",
                                cursor: "pointer",
                              }}
                            />
                            <DescriptionOutlinedIcon
                              onClick={() => {
                                setOpenLedger(true);
                                setId(item?.id);
                              }}
                              sx={{
                                backgroundColor: "#0c73a3",
                                p: "4px",
                                width: "18px",
                                color: "white",
                                borderRadius: "5px",
                                cursor: "pointer",
                              }}
                            />
                            <RemoveRedEyeOutlinedIcon
                              onClick={() => {
                                setDetailsModal(true);
                                setId(item?.id);
                              }}
                              sx={{
                                backgroundColor: "#0067FF",
                                p: "4px",
                                width: "18px",
                                color: "white",
                                borderRadius: "5px",
                                cursor: "pointer",
                              }}
                            />
                            <EditOutlinedIcon
                              onClick={() => {
                                setEditSupplierOrderModal(true);
                                navigate("/pharmacy", { state: item });
                                setId(item?.id);
                              }}
                              sx={{
                                backgroundColor: "#FF8D1E",
                                p: "4px",
                                width: "18px",
                                color: "white",
                                borderRadius: "5px",
                                cursor: "pointer",
                              }}
                            />
                            <DeleteForeverOutlinedIcon
                              onClick={() => {
                                setDeleteModal(true);
                                setId(item?.id);
                              }}
                              sx={{
                                backgroundColor: "#FF392B",
                                p: "4px",
                                width: "18px",
                                color: "white",
                                borderRadius: "5px",
                                cursor: "pointer",
                              }}
                            />
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                ) : (
                  <TableRow>
                    <TableCell
                      sx={{
                        textAlign: "center",
                      }}
                      colSpan={15}
                    >
                      <Typography color={"black"} variant="heading2">
                        Data Not Found
                      </Typography>{" "}
                    </TableCell>
                  </TableRow>
                )}
              </Table>
            </TableContainer>
          </Grid>
        </Box>

        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
          gap={1}
          sx={{ zIndex: 10, px: "20px", mb: "5px" }}
        >
          {/* Export icons */}
          <Box sx={{ display: "flex", gap: "8px", alignItems: "center" }}>
            <Box sx={{ cursor: "pointer" }} onClick={() => handleDownloadCsvSupplier(supplierList?.payload?.suppliers)}>
              <img src={csv_icon} alt="" width="28px" />
            </Box>
            <Box sx={{ cursor: "pointer" }} onClick={() => handleShowJson(supplierList?.payload?.suppliers)}>
              <img src={json_icon} alt="" />
            </Box>
          </Box>

          {/* Pagination */}
          <Box display="flex" alignItems="center" flexWrap="wrap" gap={1}>
            <Button
              onClick={handlePrevious}
              disabled={page === 1}
              startIcon={<ArrowBackIcon sx={{ fontSize: "14px" }} />}
              sx={{ fontSize: "12px", textTransform: "none", color: page === 1 ? "#9e9e9e" : "#007A99", "&:disabled": { color: "#9e9e9e" } }}
            >
              Prev
            </Button>

            {(() => {
              if (totalPage <= 7) return [...Array(totalPage)].map((_, i) => i + 1);
              const pages = [];
              pages.push(1);
              if (page > 3) pages.push("...");
              for (let p = Math.max(2, page - 1); p <= Math.min(totalPage - 1, page + 1); p++) pages.push(p);
              if (page < totalPage - 2) pages.push("...");
              pages.push(totalPage);
              return pages;
            })().map((p, i) =>
              p === "..." ? (
                <Typography key={`ellipsis-${i}`} sx={{ fontSize: "12px", px: "4px", color: "#999" }}>…</Typography>
              ) : (
                <Button
                  key={p}
                  onClick={() => setPage(p)}
                  sx={{
                    minWidth: "30px", height: "30px", fontSize: "12px", borderRadius: "6px", p: "2px",
                    color: page === p ? "#fff" : "#333",
                    backgroundColor: page === p ? "#007A99" : "#fff",
                    border: "1px solid #d0d0d0",
                    "&:hover": { backgroundColor: page === p ? "#007A99" : "#f2f2f2" },
                  }}
                >
                  {p}
                </Button>
              )
            )}

            <Button
              onClick={handleNext}
              disabled={page === totalPage || totalPage === 0}
              endIcon={<ArrowForwardIcon sx={{ fontSize: "14px" }} />}
              sx={{ fontSize: "12px", textTransform: "none", color: (page === totalPage || totalPage === 0) ? "#9e9e9e" : "#007A99", "&:disabled": { color: "#9e9e9e" } }}
            >
              Next
            </Button>

            <Box display="flex" alignItems="center" gap="4px">
              <Typography sx={{ fontSize: "12px", color: "#555" }}>Go to</Typography>
              <TextField
                size="small"
                type="number"
                value={goToPage}
                onChange={(e) => setGoToPage(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    const n = parseInt(goToPage, 10);
                    if (n >= 1 && n <= totalPage) { setPage(n); setGoToPage(""); }
                  }
                }}
                sx={{ width: "60px", "& input": { fontSize: "12px", padding: "6px 8px" }, "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
              />
            </Box>

            <FormControl size="small" sx={{ minWidth: 80 }}>
              <InputLabel sx={{ fontSize: "12px" }}>Rows</InputLabel>
              <Select
                value={itemPerPage}
                label="Rows"
                onChange={(e) => { setItemPerPage(e.target.value); setPage(1); }}
                sx={{ fontSize: "12px", borderRadius: "8px" }}
              >
                {[10, 20, 50, 100].map((n) => (
                  <MenuItem key={n} value={n} sx={{ fontSize: "12px" }}>{n}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Box>
      </Box>
      <CustomModal
        customStyles={{ border: "none", minWidth: "85%" }}
        open={detailsModal}
        setDetailsModal
        onClose={() => setDetailsModal(false)}
      >
        <SupplierDetails
          onClose={() => setDetailsModal(false)}
          id={id}
          refetch={refetch}
          page={page}
          itemPerPage={itemPerPage}
        />
      </CustomModal>

      <CustomModal
        customStyles={{ border: "none", minWidth: "85%", maxWidth: "85%" }}
        open={editSupplierOrderModal}
        onClose={() => setEditSupplierOrderModal(false)}
      >
        <EditSupplier
          onClose={() => setEditSupplierOrderModal(false)}
          id={id}
          refetch={refetch}
        />
      </CustomModal>

      <CustomModal
        customStyles={{ border: "none", minWidth: "85%", maxWidth: "85%" }}
        open={newPurchaseOrderModal}
        onClose={() => setNewPurchaseOrderModal(false)}
      >
        <NewSupplier
          onClose={() => setNewPurchaseOrderModal(false)}
          refetch={refetch}
        />
      </CustomModal>

      <CustomModal
        customStyles={{ border: "none", width: "76%" }}
        open={openLedger}
        onClose={() => setOpenLedger(false)}
      >
        <LedgerEntries onClose={() => setOpenLedger(false)} id={id} />
      </CustomModal>

      <CustomModal
        customStyles={{ border: "none", minWidth: "85%", maxWidth: "92%" }}
        open={supplierPaymentModal}
        onClose={() => setSupplierPaymentModal(false)}
      >
        <AddlegderEntries
          onClose={() => setSupplierPaymentModal(false)}
          id={id}
          refetch={refetch}
        />
      </CustomModal>
    </>
  );
};

export default Supplier;
